module.exports = {"pt-BR":{"timeline":{"property-state-change-card":{"message":"alterou a situação do imóvel de","to":"para"}}}}